import React from 'react';
import { motion } from 'framer-motion';

const visionList = [
    "We focus on enhancing eco-friendly operations",
    "We lead sustainability transformation through process improvements, innovation, and disruption",
    "We focus on responsible business growth",
    "We aim to be rated amongst the top brands to work for"
];

const OurVisionSection = () => {
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: { staggerChildren: 0.12 }
        }
    };

    const itemVariants = {
        hidden: { opacity: 0, x: -20 },
        visible: {
            opacity: 1,
            x: 0,
            transition: { duration: 0.5, ease: "easeOut" }
        }
    };

    return (
        <section className="w-full bg-[#FFFFFF] pb-16 lg:pb-24 overflow-hidden select-none text-left">
            <div className="max-w-[1440px] w-full mx-auto px-[20px] lg:px-[80px]">

                <div className="w-full flex flex-col md:flex-row md:items-start justify-between gap-6 mb-[30px] lg:mb-[60px]">
                    <h2
                        className="text-[#01386A] text-[20px] lg:text-[30px] font-sora font-[600] tracking-tight leading-none min-w-[200px]"
                    >
                        Our Vision
                    </h2>
                    <p
                        className="text-[#49577A] text-[14px] sm:text-[16px] leading-relaxed max-w-[552px] font-[500] font-graphik"
                    >
                        We remain among the top five IT service providers worldwide and maintain our role within India as a leader in sustainability.
                    </p>
                </div>

                <div className="w-full flex lg:flex-row flex-col items-stretch">

                    <motion.div
                        variants={containerVariants}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.2 }}
                        className="lg:max-w-[709px] w-full bg-[#F1F1F1] p-8 sm:p-12 lg:p-16 flex flex-col justify-center"
                    >
                        <div className="flex flex-col gap-6 w-full">
                            {visionList.map((text, index) => (
                                <motion.div
                                    key={index}
                                    variants={itemVariants}
                                    className="flex items-start gap-4 group"
                                >
                                    <span className="text-[#EA580C] font-[700] text-[18px] sm:text-[20px] leading-none select-none mt-0.5 shrink-0 transition-transform duration-300 group-hover:translate-x-1">
                                        &gt;
                                    </span>
                                    <p
                                        className="text-[14px] lg:text-[16px] text-[#49577A] font-graphik leading-relaxed font-[500] transition-colors duration-200 group-hover:text-[#002D62]"
                                    >
                                        {text}
                                    </p>
                                </motion.div>
                            ))}
                        </div>
                    </motion.div>

                    <div className="lg:max-w-[572px] w-full min-h-[260px] sm:min-h-[340px] lg:min-h-full relative overflow-hidden bg-[#020b1e] group cursor-pointer">
                        <img
                            src="/assets/sustainability/img2.png"
                            alt="3D Glowing blue abstract structural geometric twist tunnel artwork"
                            className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                        />
                    </div>

                </div>

            </div>
        </section>
    );
};

export default OurVisionSection;